import {roomWaitingApi} from "@/core/api/room.waiting.api";

export default {
  findAllByRoomIdApi: async ({dispatch, commit, getters, rootGetters}, {roomId}) => {
    const users = await roomWaitingApi.findAllByRoomId({roomId});
    commit('SET_WAITING_LIST', users);
  },

  isEnabled: async ({dispatch, commit, getters, rootGetters}, {roomId}) => {
    return await roomWaitingApi.isEnabled({roomId});
  },

  approveApi: async ({dispatch, commit, getters, rootGetters}, {roomId, userId, roleId}) => {
    await roomWaitingApi.approve({type: 'approve', roomId, userId, roleId});
  },

  disapproveApi: async ({dispatch, commit, getters, rootGetters}, {roomId, userId, roleId}) => {
    await roomWaitingApi.disapprove({type: 'disapprove', roomId, userId, roleId});
  },

  requestEnterApi: async ({dispatch, commit, getters, rootGetters}, data) => {
    return await roomWaitingApi.requestEnter(data);
  },

  leaveWaitingRoomApi: async ({dispatch, commit, getters, rootGetters}, data) => {
    await roomWaitingApi.leaveWaitingRoom(data);
  },

  disableWaitingRoomApi: async ({dispatch, commit, getters, rootGetters}, data) => {
    await roomWaitingApi.disableWaitingRoom(data);
  },

  sendTestNoManagerInRoomApi: async ({dispatch, commit, getters, rootGetters}, data) => {
    await roomWaitingApi.testNoManagerInRoom(data);
  },
  sendTestCloseRoomApi: async ({dispatch, commit, getters, rootGetters}, data) => {
    await roomWaitingApi.testCloseRoom(data);
  },
}